// Feature flags for MVP and future upgrades
// Set to true to enable a feature, false to hide it
export const FEATURES = {
  // MVP Features (enabled)
  home: true,
  about: true,
  contact: true,

  // Future Features (disabled for MVP)
  tours: false,
  gallery: true,
  faq: false,
  terms: false,
  privacy: false,

  // Home Page Sections (MVP - hero only)
  homeImageGallery: false,
  homeTestimonials: false,
  homeAboutPreview: false
};

// Helper function to check if a feature is enabled
export const isFeatureEnabled = (feature) => FEATURES[feature] ?? false;
